import type { Thunk } from 'state/state.common';
import type { MakePartial } from 'types/utils';

import { showNotification } from './notification.action';
import type { UserNotification } from './notification.model';

export function showNotificationThunk(
  notification: MakePartial<UserNotification, 'id' | 'closeAutomatically'>,
): Thunk<void> {
  return (dispatch, _getState, { getNewGuid }) => {
    dispatch(
      showNotification({
        id: notification.id ?? getNewGuid(),
        closeAutomatically: notification.closeAutomatically ?? true,
        ...notification,
      }),
    );
  };
}
